import { render, staticRenderFns } from "./taskListDetail.vue?vue&type=template&id=4d8c8224&scoped=true&"
import script from "./taskListDetail.vue?vue&type=script&lang=js&"
export * from "./taskListDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskListDetail.vue?vue&type=style&index=0&id=4d8c8224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c8224",
  null
  
)

export default component.exports